import {Directive, Inject, Injectable, Optional} from '@angular/core';
import {
  HashMap,
  TranslateParams,
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_FALLBACK_STRATEGY,
  TRANSLOCO_INTERCEPTOR,
  TRANSLOCO_LOADER,
  TRANSLOCO_MISSING_HANDLER,
  TRANSLOCO_TRANSPILER,
  TranslocoConfig, TranslocoDirective,
  TranslocoFallbackStrategy,
  TranslocoInterceptor,
  TranslocoLoader,
  TranslocoMissingHandler,
  TranslocoService,
  TranslocoTranspiler
} from "@jsverse/transloco";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {
  }

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/api/config/i18n?culture=${lang}`).pipe(map(value => value.data));
  }
}

@Injectable({
  providedIn: 'root'
})
export class BaseTranslocoWithKeyService extends TranslocoService {
  protected hasEditLocalizationRole: boolean;
  protected hasTranslationKeysInUi: boolean;

  constructor(
    @Optional() @Inject(TRANSLOCO_LOADER) loader: TranslocoLoader,
    @Inject(TRANSLOCO_TRANSPILER) parser: TranslocoTranspiler,
    @Inject(TRANSLOCO_MISSING_HANDLER) missingHandler: TranslocoMissingHandler,
    @Inject(TRANSLOCO_INTERCEPTOR) interceptor: TranslocoInterceptor,
    @Inject(TRANSLOCO_CONFIG) userConfig: TranslocoConfig,
    @Inject(TRANSLOCO_FALLBACK_STRATEGY) fallbackStrategy: TranslocoFallbackStrategy
  ) {
    super(loader, parser, missingHandler, interceptor, userConfig, fallbackStrategy);
  }

  translate<T = any>(key: TranslateParams, params: HashMap = {}, lang = this.getActiveLang()): T {
    if (typeof key === 'string' && key.startsWith('help')) return key as any;
    let t = super.translate<T>(key, params, this.ensureAvailableLang(lang));
    if (this.hasTranslationKeysInUi) {
      if (t.toString() === key) {
        return ('\u2757' + key) as unknown as T;
      } else {
        return (`${t}\u2754${key}`) as unknown as T;
      }
    }
    if (t.toString() === key) {

      if (!this.config.missingHandler?.logMissingKey) {
        let prefix: string = params?.prefix;
        if (prefix == null) {
          let ix = key.lastIndexOf(' ');
          if (ix == -1) {
            ix = key.lastIndexOf('.');
          } else {
            ix = key.substring(0, ix).lastIndexOf('.');
          }
          if (ix > -1) {
            prefix = key.substring(0, ix);
          }
        }

        if (!prefix?.endsWith('.')) {
          prefix += '.';
        }

        t = key.replace(prefix, '') as unknown as T;
      }
    }

    return t;
  }

  protected ensureAvailableLang(lang: string): string {
    const availableLangs = this.getAvailableLangs() as string[];
    return availableLangs.includes(lang) ? lang : this.getDefaultLang();
  }
}
